import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetModelConfig } from '@swf/core/store';
import type { BasicSportsWidgetConfig } from '@swf/sports/pages/types';

import { defaultState } from './defaultState';
import { effects } from './effects';
import { reducers } from './reducers';
import { selectors } from './selectors';
import type { SportsEventTypeInfoState } from './types';

export interface SportsEventTypeInfoWidgetModel
  extends WidgetModelConfig<BasicSportsWidgetConfig, SportsEventTypeInfoState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export const sportsEventTypeInfoWidgetModel: SportsEventTypeInfoWidgetModel = {
  state: defaultState,
  reducers,
  effects,
  selectors
};

export const useSportsEventTypeInfoWidget: UseWidget<
  BasicSportsWidgetConfig,
  SportsEventTypeInfoWidgetModel
> = useWidget;
